
// region JS Imports

// region External Modules
import on_domready from "domready"
import u from "umbrellajs"
import { getNoty } from "plugins/noty"
import {
  requestIdleCallback,
} from "plugins/request-animation-frame-polyfill"
// endregion External Modules

// Private Modules
import WaitObjectByPathPromise from "app/wait_object_by_path_promise"
// Private Modules

// region Public Components
// endregion Public Components

// region Private Components
// endregion Private Components

// endregion JS Imports

const text_selectors = {
  notice:   "#mod-flash-notice",
  success:  "#mod-flash-success",
  error:    "#mod-flash-error",
  warning:  "#mod-flash-warning",
  info:     "#mod-flash-info",
}

const Notifier = {
  closeAll(){
    getNoty()
    .then((Noty) => {
      Noty.closeAll()
    })
  },
  showNotice(message: string, timeout: number = 3000){
    getNoty()
    .then((Noty) => {
      new Noty({
        text:         message,
        timeout:      timeout,
      }).show()
    })
  },
  showSuccess(message: string, timeout: number = 3000){
    getNoty()
    .then((Noty) => {
      new Noty({
        text:     message,
        type:     "success",
        timeout:  timeout,
      }).show()
    })
  },
  showError(message: string, timeout: number = 3000){
    getNoty()
    .then((Noty) => {
      new Noty({
        text:         message,
        type:         "error",
        timeout:      timeout,
      }).show()
    })
  },
  showWarning(message: string, timeout: number = 3000){
    getNoty()
    .then((Noty) => {
      new Noty({
        text:         message,
        type:         "warning",
        timeout:      timeout,
      }).show()
    })
  },
  showInfo(message: string, timeout: number = 3000){
    getNoty()
    .then((Noty) => {
      new Noty({
        text:         message,
        type:         "information",
        timeout:      timeout,
      }).show()
    })
  },
  // facade pattern
  show(type: string, message: string, timeout: number = 3000){
    switch (type){
      case "notice":
        Notifier.showNotice(message, timeout)
        break

      case "success":
        Notifier.showSuccess(message, timeout)
        break

      case "error":
        Notifier.showError(message, timeout)
        break

      case "warning":
        Notifier.showWarning(message, timeout)
        break

      case "info":
        Notifier.showInfo(message, timeout)
        break

      default:
        break
    }
  },

  onPageLoad(){
    requestIdleCallback(() => {
      on_domready(() => {
        WaitObjectByPathPromise("window._spacious_main_css_loaded")
        .then(() => {
          Object.entries(text_selectors).forEach(([msg_type, dom_selector]) => {
            // jquery text must return string so we only check empty string
            const text: string = u(dom_selector).text()

            if ( text.trim().length > 0 ){
              Notifier.show(msg_type, text)
            }
          })
        })
        .done()
      })
    })
  },

  showSpaciousBlackAlert(message: string, timeout: number | false = false) {
    import(
      "noty"
    )
    .then(({default: Noty}) => {
      new Noty({
        text:         message,
        timeout:      timeout,
        type:         "alert",
        layout:       "bottomLeft",
        theme:        "mint",
        progressBar:  false,
      }).show()
    })
  },
}

export default Notifier
